import templateUrl from 'emun.vendor/vendor-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";

class VendorListController {
    constructor($scope) {
        const $ctrl = this;
      basicController($ctrl);
      $ctrl.bus = new ServiceBus();
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.query = $ctrl.container.query;
    }
    load() {
        const $ctrl = this;
        return $ctrl.query.load.apply($ctrl.query, arguments);
    }
	toggleInactive() {
		const $ctrl = this;
		if ($ctrl.showInactive) {
			$ctrl.showInactive = false;
      $ctrl.query.criteria.active = true;
      $ctrl.query.criteria.includeInactive = false;
		} else {
			$ctrl.showInactive = true;
      $ctrl.query.criteria.active = false;
      $ctrl.query.criteria.includeInactive = true;
		}
		$ctrl.query.load(true);
  }

  create() {
    const $ctrl = this;
    $ctrl.bus.send("CreateVendor.json", $ctrl.request).then(
      function (response) {
        console.info("response", response);
        $ctrl.$state.go("vendor.dashboard", {
          vendorId: response.data.id
        });
      },
      function (response) {
        if (response.data.responseStatus.errorCode)
          modals.alert(response.data.responseStatus.message);
      }
    );
  }
}

export default {
    bindings: {
    },
    require: {
        container: '^vendorContainer'
    },
    controller: VendorListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};